import { Action, createReducer, on } from '@ngrx/store';
import { fetchAgentsList, fetchAgentsListSuccess, fetchAgentsListFailure } from './agents.action';


export interface AgentsState {
  list: any[];
  detail:any;
  loading: boolean;
  error: any;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export const initialState: AgentsState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 100,
  totalRecords: 100,
};

export const AgentsReducer = createReducer(
  initialState,
  on(fetchAgentsList, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchAgentsListSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      list: response.result,
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
      totalRecords: response.totalRecords,
    };
  }),
  on(fetchAgentsListFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  })
);

// Selector
export function reducer(state: AgentsState | undefined, action: Action) {
  return AgentsReducer(state, action);
}
